export default {
  preset: 'Preajuste',
  presets: 'Preajustes',
  clear: 'Limpiar filtro',

  isActive: {
    true: 'Solo activos',
    false: 'Solo inactivos'
  }
}
